var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarksShared(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.001,
    viewBox: "0 0 18 18.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "What_I_shared_-_Grey_icon",
    "data-name": "What I shared - Grey icon",
    transform: "translate(-7.946 -8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "external-link",
    transform: "translate(7.946 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34306",
    "data-name": "Path 34306",
    d: "M18.476,17.557h-7.91a1.121,1.121,0,0,0-1.121,1.121v9.737a1.121,1.121,0,0,0,1.121,1.121h9.759a1.121,1.121,0,0,0,1.121-1.121V20.558h1.5v8.231A2.25,2.25,0,0,1,20.7,31.037h-10.5a2.249,2.249,0,0,1-2.248-2.248V18.305a2.249,2.249,0,0,1,2.248-2.248h8.282Z",
    transform: "translate(-7.946 -13.036)",
    fill: "#989898",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34307",
    "data-name": "Path 34307",
    d: "M34.219,14.5h-1.5V10.565L22.256,21.025l-1.062-1.062L31.655,9.5H27.723V8h6.5V14.5Z",
    transform: "translate(-16.219 -8)",
    fill: "#989898",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarksShared);
export default __webpack_public_path__ + "static/media/bookmarksShared.780d6cbea8122ee5119e28f355dbc78c.svg";
export { ForwardRef as ReactComponent };